import { DateTime } from "luxon";
import I18n from '@/i18n';
import { parsedValid, isoDate, distanceFromMillis, distanceFromParsed } from "@/util/time";
import proxy from "@/util/proxy";

import * as base64 from "byte-base64";
import i18n from "@/i18n";
const md5 = require("md5");

export const WILDCARD = "*";

export const UNSAVED_LICENSE_ID = 'unsaved';

export const ALLOWED_TYPES = [
    {
        value: "H",
        label: "license.types.host",
        regEx: /^[a-z0-9-_.]+$/i,
        hint: "license.slot.validation.wrong",
        wild: false,
        host: true,
    },
    {
        value: "D",
        label: "license.types.db",
        regEx: /^[a-z0-9-_]+$/i,
        hint: "license.slot.validation.wrong",
        wild: false,
        host: false,
    },
    {
        value: "W",
        label: "license.types.any_host",
        regEx: null,
        wild: true,
        host: true,
    },
    {
        value: "P",
        label: "license.types.any_db",
        regEx: null,
        wild: true,
        host: false,
    },
];

export const MSG_TYPE = {
    UNDEF: "undef",
    ERROR: "error",
    WARN: "warn",
};

const VALIDATION_GROUP_ITEM = {
    index: null,
    isInput: null,              // true - поле ввода, false - поле типа
    state: null,
    msg_type: MSG_TYPE.UNDEF,   // true - ошибка, false - предупреждение
    message: "",
}

const NEW_ENTITY_VALIDATION_GROUP = {
    index: -1,
    isInput: true,              // true - поле ввода, false - поле типа
    state: false,
    msg_type: MSG_TYPE.ERROR,   // true - ошибка, false - предупреждение
    message: "",
}

const EMPTY_VALIDATION = {
    groups: [],
    others: []
};

const NEW_ENTITY_VALIDATION = {
    groups: [JSON.parse(JSON.stringify(NEW_ENTITY_VALIDATION_GROUP))],
    others: []
};

const NEW_ENTITY = {
    name: "",
    encoded_name: "",
    connection_type: ALLOWED_TYPES[0].value,
    suspended: false,
    _validation: JSON.parse(JSON.stringify(NEW_ENTITY_VALIDATION)),
    _new: true,
};

export const EMPTY_COUNTER = {
    regulars: 0,
    hosts: 0,
    dbs: 0,
    wild_hosts: 0,
    wild_dbs: 0,
};

export const EMPTY_SUMMARY = {
    subtotal: 0, // Если установить то выведется на экран!
    min_price: 0, // Если установить то выведется на экран!
    price: 0, // Если установить то выведется на экран!
    items: [],
};

export const NEW_LICENSE = {
    package: {
        id: 1,
        name: "",
        description: "",
        item_price: 200,
        wildcard_price: 4500,
        min_items: 5,
        max_wildcard: 2,
        itemized_days: 366,
        evaluation_days: 31
    },
    name: "",
    description: "",
    suspended: false,
    timezone: "",
    connections: [],
    created_on: DateTime.now().setZone('utc').toISO(),
    _new: true,
};

export var licenseObject = {
    _last_dummy_id: -1,
    _group_idx: -1,
    data: {},

    init: function (params, keepExistedNames = false) {
        if (keepExistedNames) {
            this._prev = JSON.parse(JSON.stringify(this.data));
        }

        this.data = {};
        let conn_idx = 0;
        while (conn_idx < params.connections.length) {
            let conn = params.connections[conn_idx];
            let e_idx = 0;
            while (e_idx < conn.entities.length) {
                let e = conn.entities[e_idx];
                if (keepExistedNames) {
                    e.name = this._prev.connections[conn_idx].entities[e_idx].name;
                }
                e._validation = JSON.parse(JSON.stringify(EMPTY_VALIDATION));
                e_idx++;
            }
            conn._summary = {};
            conn._summary = JSON.parse(JSON.stringify(EMPTY_SUMMARY));
            //this.calcConnSummary(conn, params.package);
            conn_idx++;
        }
        params._summary = {};
        params._summary = JSON.parse(JSON.stringify(EMPTY_SUMMARY));
        this.data = proxy(params);
        this.validate();
        this.calcSummary(params.package);

        if (keepExistedNames) delete this._prev;

        return this;
    },

    lastId: function () {
        return this._last_dummy_id
    },

    initData: function (obj = null, special = null) {
        let created = JSON.parse(JSON.stringify(obj ? obj : NEW_LICENSE));

        if (special) {
            if (special.type == 'locals') {
                created.name = i18n.t('license.local_names')
                // Этот state нужен только для отображения свеже-созданного обьекта!
                // Маппинг на сервере выбирает state в зависимости от is_individual!
                if (special.individual) {
                    created.state = PERS;
                } else {
                    created.state = TRIAL;
                }
            } else if (special.type == 'enterprise') {
                created.state = UNPAID;
            }
        }

        if (!obj) {
            created.id = this._last_dummy_id--;
            this.addSlot(created, null, special);
            //created.validate();
        }
        return created;
    },
    addSlot: function (data = this.data, type_str = null, special = null) {
        let entities;
        let valid_until;

        if (special) {
            // Эта дата нужна только для отображения свеже-созданного обьекта!
            // Маппинг на сервере выбирает valid_until в зависимости от is_individual!
            if (special.individual) {
                valid_until = DateTime.now().setZone('utc').plus({years: 1, days: 1}).endOf('day').toISODate();
            } else {
                valid_until = DateTime.now().setZone('utc').plus({days: 31}).endOf('day').toISODate();
            }

            if (special.type == 'locals') {
                entities = [];
            } else if (special.type == 'enterprise') {
                let first = Object.assign(
                    { id: this._last_dummy_id-- },
                    JSON.parse(JSON.stringify(NEW_ENTITY))
                );
                first.connection_type = ALLOWED_TYPES[2].value;
                //first.name = WILDCARD;

                let second = Object.assign(
                    { id: this._last_dummy_id-- },
                    JSON.parse(JSON.stringify(NEW_ENTITY))
                );
                second.connection_type = ALLOWED_TYPES[3].value;
                //second.name = WILDCARD;

                entities = [first, second];
            } else {
                // Тоже самое что "там"
                entities = [
                    Object.assign(
                        { id: this._last_dummy_id-- },
                        JSON.parse(JSON.stringify(NEW_ENTITY))
                    )
                ]
            }
        } else {
            valid_until = DateTime.now().setZone('utc').toISODate();

            // Тоже самое что "там"
            entities = [
                Object.assign(
                    { id: this._last_dummy_id-- },
                    JSON.parse(JSON.stringify(NEW_ENTITY))
                )
            ]
        }
        let s = proxy({
            id: 0,
            transaction_id: null,
            paid: false,
            valid_until,
            entities,
            _summary: JSON.parse(JSON.stringify(EMPTY_SUMMARY)),
            _new: true,
        });
        s.id = this._last_dummy_id--;
        if (type_str) {
            s.entities[0].connection_type = type_str;
            s.entities[0].name = WILDCARD;
        }
        data.connections.push(s);

        if (data == this.data) {
            this.validate();
            this.calcSummary();
        }
    },

    deleteSlot: function (idx) {
        this.data.connections.splice(idx, 1);
    },

    addEntity: function (conn/*, conn_idx*/) {
        let e = proxy(Object.assign(
            { id: this._last_dummy_id-- },
            JSON.parse(JSON.stringify(NEW_ENTITY))
        ));
        conn.entities.push(e);

        //this.validate();
        //this.validateEntity(e, conn_idx, conn.entities.length - 1)
        this.calcSummary();
    },

    deleteEntity: function (conn_idx, entity_idx) {
        let conn = this.data.connections[conn_idx];
        if (conn_idx > 0 && (conn._new || conn.state == NEW) && conn.entities.length == 1) {
            this.data.connections.splice(conn_idx, 1);
        } else {
            conn.entities.splice(entity_idx, 1);
            this.validate();
        }
        this.calcSummary();
    },

    isPaidSlot: function (conn) {
        return conn && conn.paid;
    },

    canDeleteConn: function (conn) {
        return conn && !this.isPaidSlot(conn);
    },

    canDelete: function () {
        return !this.data._new;
    },

    isWildcardEntity: function (entity) {
        const t = findEntityType(entity);
        return t && t.wild;
    },

    eachOtherBefore: function (entity, conn_idx, entity_idx, fn) {
        top: for (let i = 0; i < this.data.connections.length; i++) {
            let conn = this.data.connections[i];
            for (let j = 0; j < conn.entities.length; j++) {
                if (
                    (i != conn_idx || j != entity_idx) && // Не само entity
                    (i < conn_idx || (i == conn_idx && j < entity_idx)) // До самого entity, глядя с "начала" лицензии
                ) {
                    let stop = fn(entity, conn.entities[j]);
                    if (stop) break top;
                }
            }
        }
    },

    isValidEntity(entity/*, conn_idx, entity_idx*/) {
        return !entity._validation || !entity._validation.groups || entity._validation.groups.length == 0 ||
            (!entity._validation.groups.find((g) => g.state == false));
    },

    // list = null - Начало проверки всего с самого начала
    // Разница между ошибкой и предупреждением:
    // 1. Ошибка как будто нарушение уникального индекса: такое же имя того же типа, звездочка того же типа.
    // 2. Предупреждения: добавленная звездочка перекрывает имена того же типа.
    validate(list = null) {

        let group = null;

        function get_group(isInput, state, msg_type, message, arg, noIndex = false) {
            let result = JSON.parse(JSON.stringify(VALIDATION_GROUP_ITEM));
            result.index = noIndex ? -1 : !group ? this._group_idx++ : group.index;
            result.isInput = isInput;
            result.state = state;
            result.msg_type = msg_type;
            result.message = message;
            result.arg = arg;
            return result;
        }

        let type_res = null;
        let type_msg_type = MSG_TYPE.UNDEF;
        let input_res = null;
        let input_msg = "";
        let input_msg_type = MSG_TYPE.UNDEF;

        // Если list не передавался, будем проверять с начала.
        // Иначе первый элемент list становится эталоном для проверки
        let others = [];
        let entity = null;
        if (list) {
            if (list.length == 0) return;
            for (let i = 0; i < list.length; i++) {
                if (entity) {
                    others.push(list[i]);
                } else {
                    entity = list[i];
                }
            }
        } else {
            this._group_idx = 1;
            for (let i = 0; i < this.data.connections.length; i++) {
                let conn = this.data.connections[i];
                for (let j = 0; j < conn.entities.length; j++) {
                    let other = conn.entities[j];
                    other._validation = JSON.parse(JSON.stringify(EMPTY_VALIDATION));
                    if (entity) {
                        others.push(other);
                    } else {
                        entity = other;
                    }
                }
            }
        }

        if (!entity) return;
        let hasEncryptedPayload = entHasEncrypted(entity);

        // Пустой тип
        if (!entity.connection_type) {
            type_res = false;
            group = get_group.call(this, false, type_res, MSG_TYPE.ERROR, '', '', true);
            entity._validation.groups.push(group);
        }
        // Пустая строка
        if (!hasEncryptedPayload && !entity.name) {
            input_res = false;
            group = get_group.call(this, true, input_res, MSG_TYPE.ERROR, '', '', true);
            entity._validation.groups.push(group);
        }
        if (type_res != false && input_res != false) {
            let type = findEntityType(entity);

            // Допускается только одна звездочка каждого типа, если звездочка перекрывает обычных - предупредим.
            if (type_res == null && type.wild) {
                let pair_type = this.findPairType(type);
                let i = others.length;
                while (i--) {
                    let other = others[i];

                    // Сначала проверим нет ли ошибки
                    if (entity.connection_type == other.connection_type) {
                        type_res = false;
                        type_msg_type = MSG_TYPE.ERROR;

                        group = get_group.call(this, false, type_res, type_msg_type, 'license.slot.validation.exists', type.label);
                        other._validation.groups.push(group);
                        entity._validation.groups.push(group);
                        entity._validation.others.push(other);

                        others.splice(i, 1);
                    } else if (type_res != false && other.connection_type == pair_type.value) {
                        // Теперь посмотрим нет ли предупреждения
                        if (!entity._validation.groups.find(g => g.msg_type == MSG_TYPE.WARN)) {
                            type_res = true;
                            type_msg_type = MSG_TYPE.WARN;

                            entity._validation.groups.push(get_group.call(this, false, type_res, type_msg_type, 'license.slot.validation.overlaps', type.label, true));
                            entity._validation.others.push(other);

                            others.splice(i, 1);
                        }
                    }
                }
            }

            // Проверим ввод согласно типу
            if (input_res == null && type) {
                const r = type.regEx;
                if (r) {
                    // Ожидается проверка строки.
                    // Если есть только зашифрованная строка, считаем что она правильная
                    let encryptedOnly = hasEncryptedPayload && entity.name.startsWith('~');
                    if (encryptedOnly || entity.name.match(r)) {
                        let encrypted = entity.encoded_name;
                        if (!encrypted) {
                            let hash = md5(toUTF8Array(entity.name).concat(this.data.salt), {asBytes: true});
                            encrypted = "~" + base64.bytesToBase64(hash);
                        }

                        // Теперь ищем ошибки, а потом предупреждения
                        let pair_type = this.findPairType(type);
                        let i = others.length;
                        while (i--) {
                            let other = others[i];

                            let other_encrypted = other.encoded_name;
                            if (!other_encrypted) {
                                let hash = md5(toUTF8Array(other.name).concat(this.data.salt), {asBytes: true});
                                other_encrypted = "~" + base64.bytesToBase64(hash);
                            }

                            // Проверка на дублирование имени с таким же типом
                            if (
                                entity.connection_type == other.connection_type &&
                                encrypted == other_encrypted
                            ) {
                                input_res = false;
                                input_msg_type = MSG_TYPE.ERROR;

                                group = get_group.call(this, true, input_res, input_msg_type, 'license.slot.validation.exists', type.label);
                                other._validation.groups.push(group);
                                entity._validation.groups.push(group);
                                entity._validation.others.push(other);

                                others.splice(i, 1);
                            } else if (other.connection_type == pair_type.value) {
                                // А не перекрывает ли эту запись звездочка?
                                if (!other._validation.groups.find(g => g.msg_type == MSG_TYPE.WARN)) {
                                    type_res = true;
                                    type_msg_type = MSG_TYPE.WARN;
                                    other._validation.groups.push(get_group.call(this, false, type_res, type_msg_type, 'license.slot.validation.overlaps', type.label, true));
                                }
                            }
                        }
                    } else {
                        input_res = false;
                        input_msg = type.hint;
                        input_msg_type = MSG_TYPE.ERROR;

                        entity._validation.groups.push(get_group.call(this, true, input_res, input_msg_type, input_msg, true));
                    }
                } else {
                    // Звездочки.
                    input_res = true;
                }
            }
        }
        this.calcSummary();

        // Теперь запустим проверку всех оставшихся
        if (others.length > 0) this.validate(others);
    },

    isValidSlot: function (conn, conn_idx) {
        return conn.entities.every(
            (e, e_idx) => this.isValidEntity(e, conn_idx, e_idx) == true
        );
    },
/*
    isValideValue: function (conn_idx, entity_idx) {
        const entity = this.data.connections[conn_idx].entities[entity_idx];
        // Полученные с сервера (сохраненные) выделяются валидацией
        // только если они изменились
        if (entity.id > 0 && !entity.isChanged()) return null;
        return this.isValidEntity(entity, conn_idx, entity_idx);
    },
*/
    isNameDescChanged: function () {
        return this.data.isChanged("name") || this.data.isChanged("description");
    },

    isValid: function () {
        return this.data.connections.length &&
            this.data.connections.every((conn, conn_idx) =>
                this.isValidSlot(conn, conn_idx)
            )
    },

    isChangedAndValid: function () {
        return (
            this.data.isChanged() &&
            this.isValid()
        );
    },

    hasSummaryData: function () {
        return this.data._summary.items && this.data._summary.items.length > 0
    },

    // Наличие еще не сохраненного в базе слота
    hasNewbieSlot: function () {
        return !this.data.connections.every((c) => c.id > 0);
    },

    // Наличие пустого слота
    hasEmptySlot: function () {
        return this.data.connections.find((c) => c.entities.length == 0);
    },

    // Находит парный тип: если звездочка для хоста то хост, если база то звездочку для баз
    findPairType: function (ref_type) {
        return ALLOWED_TYPES.find((i) => {
            if (ref_type.host) {
                return ref_type.wild ? !i.wild && i.host : i.wild && i.host;
            } else {
                return ref_type.wild ? !i.wild && !i.host : i.wild && !i.host;
            }
        });
    },

    _count_types: function (conn, counter_obj) {
        if (!conn) return false;

        for (const e of conn.entities) {
            if (!e.suspended && this.isValidEntity(e)) {
                let t = findEntityType(e);
                if (t.wild) {
                    if (t.host) {
                        counter_obj.wild_hosts++;
                    } else {
                        counter_obj.wild_dbs++;
                    }
                } else {
                    counter_obj.regulars++;
                    if (t.host) {
                        counter_obj.hosts++;
                    } else {
                        counter_obj.dbs++;
                    }
                }
            }
        }
    },
    // Формирует отчет как накладная: чего, сколько, цена, цена с учетом условий пакета
    // Используется предварительно посчитанная структура с количеством соединений разных типов.
    _make_summary: function (counter, summary, pack = this.data.package) {
        summary.items.splice(0);
        if (counter.regulars) {
            // Если простых больше минимального пакета, либо меньше и дальше нет "звездочек"
            // выведем точное число простых, иначе выводим "минимальный пакет 1шт"
            if (counter.regulars > pack.min_items || (counter.regulars < pack.min_items && !counter.wild_hosts && !counter.wild_dbs)) {
                summary.items.push({
                    item: 'license.slot.summary.simple',
                    qty: counter.regulars,
                    price: pack.item_price,
                    amount: counter.regulars * pack.item_price,
                });
            } else {
                summary.items.push({
                    item: 'license.slot.summary.pack5',
                    qty: 1,
                    price: pack.min_items * pack.item_price,
                    amount: 1 * pack.min_items * pack.item_price,
                });
            }

        }
        if (counter.wild_hosts) {
            summary.items.push({
                item: 'license.slot.summary.wild_host',
                qty: counter.wild_hosts,
                price: pack.wildcard_price,
                amount: counter.wild_hosts * pack.wildcard_price,
            });
        }
        if (counter.wild_dbs) {
            summary.items.push({
                item: 'license.slot.summary.wild_db',
                qty: counter.wild_dbs,
                price: pack.wildcard_price,
                amount: counter.wild_dbs * pack.wildcard_price,
            });
        }

        let subtotal = 0;
        for (let i of summary.items) {
            subtotal = subtotal + i.amount;
        }

        let min_charge = pack.min_items * pack.item_price;
        if (!counter.literally && subtotal < min_charge) {
            summary.subtotal = subtotal;
            summary.min_price = min_charge;
            summary.price = min_charge;
        } else {
            summary.subtotal = 0;
            summary.min_price = 0;
            summary.price = subtotal;
        }
    },

    calcConnSummary: function (conn, pack = this.data.package) {
        if (!conn || !pack) return false;

        let c = Object.assign({ /*literally: true*/ }, EMPTY_COUNTER);
        this._count_types(conn, c);
        this._make_summary(c, conn._summary, pack);
    },

    calcSummary: function (pack = this.data.package) {
        // Общий счетчик для всех групп
        let c = Object.assign({}, EMPTY_COUNTER);
        for (let conn of this.data.connections) {
            // Не включаем в счетчик оплаченное
            if (!conn.paid || (conn.paid && !parsedValid(conn.valid_until))) this._count_types(conn, c);
            this.calcConnSummary(conn, pack);
        }
        this._make_summary(c, this.data._summary, pack);
    },

    isTypeDisabled: function (type) {
        if (!type || !type.wild) return false;
        return false;
    },
};

// Сортировка по времени создания
export function sort_by_created_on(list) {
    return list.sort(function (a, b) {
        return (
            DateTime.fromISO(a.created_on).toMillis() -
            DateTime.fromISO(b.created_on).toMillis()
        );
    });
}

export function findEntityType(entity) {
    return ALLOWED_TYPES.find((i) => i.value === entity.connection_type);
}

export function str2type(s) {
    return ALLOWED_TYPES.find((i) => i.value === s);
}

// === Сущьности ================================================================

export function entIsWildcard(entity) {
    return findEntityType(entity).wild
}

export function entHasEncrypted(entity) {
    return (entity.encoded_name && entity.encoded_name.trim().length > 0) ? true : false
}

export function entHasOnlyEncrypted(entity) {
    return (entHasEncrypted(entity) && !entHasReadable(entity)) ? true : false
}

export function entHasReadable(entity) {
    return (entity.name && !entity.name.trim().startsWith('~')) ? true : false
}

// === Соединения ===============================================================

const NEW = 'New';
const UNPAID = 'Unpaid';
const PAID = 'Paid';
const TRIAL = 'Trial';
const PERS = 'Pers';

export function isConPaid(conn) {
    return conn.state == PAID
}

export function isConUnpaid(conn) {
    return conn.state == UNPAID
}

export function isConDraft(conn) {
    return conn.state == NEW;
}

export function isConNonPersonalTrial(conn) {
    return conn.state == TRIAL;
}

export function isConHasNoWildcards(conn) {
    return conn.entities.length == 0 ||
        conn.entities.every(e => findEntityType(e).wild != true)
}

export function conRegularsCount(conn) {
    return conn.entities.filter(e => findEntityType(e).wild != true).length
}

// Соединение не пустое и внутри все правильное
export function conNotEmptyAndValid(conn) {
    return conn && conn.entities && conn.entities.length > 0 && conn.entities.every((e) => !e.suspended && (
        !e._validation || !e._validation.groups || e._validation.groups.length == 0 ||
        !e._validation.groups.find((g) => g.state == false)))
}

// НЕ пустой слот ожидает оплаты
export function conAwaitingPayment(conn) {
    // Свеже-созданное, не оплаченное
    let other = (conn._new || conn.state == NEW || conn.state == UNPAID ||
        // или оплаченное с вышедшим сроком действия и не все внутри Suspended
        (conn.state == PAID && !parsedValid(conn.valid_until) && !conSuspended(conn)) ||
        // или триал и не все внутри Suspended
        ((conn.state == TRIAL || conn.state == PERS) && !conSuspended(conn)));
    return conNotEmptyAndValid(conn) && other;
}

// state подходящий и срок в годности в будущем
export function conActive(conn) {
    return (conn.state == PAID || conn.state == TRIAL || conn.state == PERS) && parsedValid(conn.valid_until)
}

// Срок действия может выйти только у триала и оплаченной,
// но так как есть внешнее изменение paid на unpaid, итоговый список такой:
// trial, paid, unpaid
export function conExpired(conn) {
    return !conn._new && conn.state != NEW &&
        ((conn.state == UNPAID && conn.transaction_id) ||
            ((conn.state == TRIAL || conn.state == PAID) && conn.valid_until && !parsedValid(conn.valid_until)))
}

export function conSummaryVisible(conn) {
    return !(isConPaid(conn) && !conExpired(conn));
}

//
export function conSuspended(conn) {
    return conn.entities.length > 0 && conn.entities.every((item) => item.suspended == true)
}

export function conActiveTrial(conn) {
    return (conn.state == TRIAL || conn.state == PERS) && conn.valid_until && parsedValid(conn.valid_until)
}

// Этот слот триальный и создан сегодня?
export function isConSameDayTrial(conn, package_obj) {
    if (conn.state == TRIAL) {
        let now = DateTime.now().setZone('utc');
        now = DateTime.utc(now.year, now.month, now.day);
        let t = DateTime.fromISO(conn.valid_until, { zone: 'utc' });
        let diff = t.diff(now, ["days"]);
        return diff.days == package_obj.evaluation_days;
    }
    return false;
}

// Сколько можно добавить "простых" имен в уже оплаченный слот
// Здесь используется допущение, что оплаченный слот уже содержит обычное имя
// потому что их нельзя удаить из оплаченного слота.
export function conPaidNamesRemaining(conn, package_obj) {
    let regulars = conRegularsCount(conn);
    return isConPaid(conn) && regulars > 0 ? Math.max(0, package_obj.min_items - regulars) : 0;
}

export function conCanAddEntity(conn, package_obj) {
    return conn._new ||
        conn.state == NEW ||
        conn.state == PERS ||
        conn.state == UNPAID ||
        (conn.state == TRIAL && conn.entities.length < package_obj.min_items) ||
        conPaidNamesRemaining(conn, package_obj) > 0;
}

export function conValidUntilDate(conn) {
    let parsed = isoDate(conn.valid_until);
    return I18n.d(new Date(parsed.toMillis()), "short");
}

export function conValidUntilDistance(conn) {
    return distanceFromParsed(conn.valid_until)
}

export function conValidUntilFormatted(conn) {
    let parsed = isoDate(conn.valid_until);
    return parsed ? (
        I18n.d(new Date(parsed.toMillis()), "short") +
        " (" +
        distanceFromParsed(conn.valid_until) +
        ")"
    ) : 'n/a';
}

export function conType(conn) {
    if (conn.state == PERS || conn.state == TRIAL) {
        return I18n.t('license.slot.states.trial')
    } else if (conn.state == NEW || conn._new) {
        return I18n.t('license.slot.states.draft')
    } else if (conn.state == UNPAID) {
        return I18n.t('license.slot.states.unpaid')
    } else {
        return I18n.t('license.slot.states.paid')
    }
}

export function conTypeWithState(conn) {
    let result = conType(conn);
    let state = '';
    if (conExpired(conn)) {
        if (conSuspended(conn)) {
            // "Закончился срок действия, продление отключено"
            state = I18n.t('license.slot.states.expired_suspended')
        } else {
            // "Закончился срок действия"
            state = I18n.t('license.slot.states.expired')
        }
    } else {
        if (conn.state == PERS || conn.state == TRIAL || conn.state == PAID) {
            // "до {0}"
            state = I18n.t('license.slot.states.until_to', [conValidUntilFormatted(conn)])
        }
    }
    if (result.length > 0) {
        return state.length > 0 ? result + ': ' + state : result
    } else {
        return state
    }
}

// === Лицензии ===============================================================

export function isPersonalTrial(license) {
    return license.state == PERS;
}

export function isNonPersonalTrial(license) {
    return license.state == TRIAL;
}

export function isTrial(license) {
    return isPersonalTrial(license) || isNonPersonalTrial(license);
}

export function isDraft(license) {
    return license.state == NEW;
}

export function isEncrypted(license) {
    return license.encrypt
}

// Префикс can отвечает на вопрос "Видна такая кнопка?"
export function canDelete(license) {
    return license.state == NEW;
}

// Префикс can отвечает на вопрос "Видна такая кнопка?"
export function canPay(license) {
    return !license._new;// license.state != PERS; // && !license._new;
}

// Префикс can отвечает на вопрос "Видна такая кнопка?"
export function canDownload(license) {
    return !license._new;
}

// Префикс can отвечает на вопрос "Видна такая кнопка?"
export function canSave(license) {
    // Новый Pers и его аналог для бизнеса
    return (license._new && (isPersonalTrial(license) || isNonPersonalTrial(license))) ||
        // Остальное
    (license.connections && license.connections.find(c => c.state == PAID || c.entities.length > 0));
}

// Конец действия будет и был сегодня
export function isExpirationToday(license) {
    let last = lastInFutureMillis(license)
    if (last) {
        return distanceFromMillis(last) ? false : true
    } else {
        return false
    }
}

// Следующее списание средств
export function nextBillMillis(license) {
    return Math.min.apply(
        Math,
        license.connections.map(function (c) {
            return isoDate(c.valid_until).toMillis();
        })
    );
}

export function nextBillFormated(license) {
    let nearest = nextBillMillis(license);
    let distance = distanceFromMillis(nearest);
    if (distance) {
        return I18n.t("license.next_charge_in", [
            I18n.d(new Date(nearest), "short"),
            distanceFromMillis(nearest),
        ]);
    } else {
        return I18n.t("license.next_charge", [
            I18n.d(new Date(nearest), "short")
        ]);
    }
}

export function lastInFutureMillis(license) {
    let result = DateTime.now().setZone('utc').toMillis();
    let found = false;
    license.connections.forEach((con) => {
        let t = DateTime.fromISO(con.valid_until, { zone: 'utc' }).endOf('day').toMillis()
        if (t > result) {
            result = t;
            found = true;
        }
    });
    return found ? result : null;
}

// Только дата
export function validUntilDate(license) {
    let last = lastInFutureMillis(license)
    return I18n.d(new Date(last), "short")
}

// Дата и сколько до нее либо только дата
export function validUntilFormatted(license) {
    let last = lastInFutureMillis(license)
    if (last) {
        // Sep 9, 2021 (1 месяц 6 дней)
        let distance = distanceFromMillis(last);
        if (distance) {
            return (
                I18n.d(new Date(last), "short") +
                " (" +
                distanceFromMillis(last) +
                ")"
            );
        } else {
            // Срок выходит сегодня, возможно "вышел" сегодня
            // На выходе только дата!
            return I18n.d(new Date(last), "short")
        }
    } else {
        return ""
    }
}

// Только локальные имена, включая оплаченные
export function localNames(license) {
    // (license.state == PERS || license.state == TRIAL) &&
    return license.connections.length == 1 && license.connections[0].entities.length == 0
}

// Лицензия содержит хотя бы одно юзабельное соединение
export function hasActiveConnection(license) {
    return license.connections.find(con => conActive(con)) ? true : false;
}

// Лицензия содержит хотя бы одно оплаченное соединение
export function hasPaidConnection(license) {
    return license.connections.find(con => isConPaid(con)) ? true : false;
}

// Лицензия ожидает оплаты, в смысле "внутри что то можно оплатить"
export function somethingAwaitingPayment(license) {
    // Персональный триал на локальные имена оплатить нельзя!
    return !isPersonalTrial(license) && license.connections && license.connections.length >= 1 &&
        // Если локальные имена бизнес (один пустой слот в лицензии), либо есть не пустой слот на оплату
        ((isNonPersonalTrial(license) && license.connections.length == 1 && license.connections[0].entities.length == 0) ||
        license.connections.find((con) => conAwaitingPayment(con))) ? true : false
}

// Лицензия содержит только "приостановленные" сущьности
export function suspended(license) {
    return license.connections.every((con) =>
        conSuspended(con)
    )
}

// Лицензия содержит хотябы одно соединение с вышедшим сроком годности,
// а остальные либо наброски либо тоже вышел строк годности
export function expired(license) {
    return license.connections.find(con => conExpired(con)) && license.connections.every(con => conExpired(con) || isConDraft(con))
}

// Лицензия содержит только конекшены с вышедшем сроком годности, внутри все suspended
export function expiredSuspended(license) {
    return license.connections.every((con) =>
        // Cрок годности вышел
        !parsedValid(con.valid_until) &&
        (license.state == PERS || conSuspended(con))
    )
}

// Есть чего нибудь внутри лицензии на оплату, включая "Активные".
export function getUnpaid(list) {
    return sort_by_created_on(
        list.filter(
            (item) =>
                // Сейчас вроде невозможно сохранить пустое, потом посмотрим
                //item.connections.length == 0 ||
                (somethingAwaitingPayment(item) && !expiredSuspended(item))
        )
    );
}

// Активные, те что можно юзать из консольки. Исключая те, в которых можно чего нибудь оплатить.
export function getActive(list) {
    return sort_by_created_on(
        list.filter((item) =>
            !somethingAwaitingPayment(item) &&
            !expiredSuspended(item) &&
            hasActiveConnection(item)
        )
    );
}

// Внутри все с полностью истекшим сроком годности.
export function getArchive(list) {
    return sort_by_created_on(
        list.filter((item) =>
            expiredSuspended(item)
        )
    );
}

export function getLicenseName(license) {
    return license.name ? license.name :
        (license.id && license.id > 0) ? license.id : i18n.t('license.untitled');
}

export function isUnsavedId(field) {
    return String(field).startsWith("-");
}

export function toRequestObj(license) {
    return {
        personal: false,
        //encrypt,
        name: license.name,
        description: license.description,
        connections: license.connections.map((conn) => ({
            id: conn.id,
            entities: conn.entities.map(item => {
                let encrypted = entHasOnlyEncrypted(item)/* && item.name.trim().length == 0;*/
                return {
                    id: item.id,
                    // Если нет читаемого имени - отправим хеш
                    name: encrypted ? item.encoded_name : item.name,
                    connection_type: item.connection_type,
                    suspended: item.suspended,
                    //encrypted
                }
            }),
        })),
    };
}

// Сейчас дублирует названия состояний слота!
export function licenseType(license) {
    if (license.state == PERS || license.state == TRIAL) {
        return I18n.t('license.slot.states.trial')
    } else if (license.state == NEW || license._new) {
        return I18n.t('license.slot.states.draft')
    } else if (license.state == UNPAID) {
        return I18n.t('license.slot.states.unpaid')
    } else {
        return I18n.t('license.slot.states.paid')
    }
}

// Сейчас дублирует такой же метод для слота!
export function licenseTypeWithState(license) {
    let result = licenseType(license);
    let state = '';
    if (expired(license)) {
        if (conSuspended(license)) {
            state = I18n.t('license.slot.states.expired_suspended')
        } else {
            state = I18n.t('license.slot.states.expired')
        }
    } else {
        if (license.state == PERS || license.state == TRIAL || license.state == PAID) {
            state = 'до ' + I18n.t('license.slot.states.until_to', [validUntilFormatted(license)])
        }
    }
    if (result.length > 0) {
        return state.length > 0 ? result + ': ' + state : result
    } else {
        return state
    }
}

/* ========================= */

function toUTF8Array(str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
        } else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(
                0xe0 | (charcode >> 12),
                0x80 | ((charcode >> 6) & 0x3f),
                0x80 | (charcode & 0x3f)
            );
        }
        // surrogate pair
        else {
            i++;
            charcode = ((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff);
            utf8.push(
                0xf0 | (charcode >> 18),
                0x80 | ((charcode >> 12) & 0x3f),
                0x80 | ((charcode >> 6) & 0x3f),
                0x80 | (charcode & 0x3f)
            );
        }
    }
    return utf8;
}
